import { useMemo } from "react";
import { QITable, QISlideSelect, QISpinner } from "../../../components";

const LOAD_MORE_THRESHOLD = 0.9;

export const EventsTableWrapper = ({
  data,
  header,
  isLoading,
  isSuccess,
  tableHandlers = {},
  highlight,
  setHighlight,
  listType,
  selectedId,
  batchSize,
  onBatchSizeChange = () => {},
  hasMore,
  isLoadingMore,
  onLoadMore = () => {},
}) => {
  const batchControl = useMemo(
    () => ({
      page: 1,
      perPage: batchSize,
      onPageChange: () => {},
      onPerPageChange: onBatchSizeChange,
    }),
    [batchSize, onBatchSizeChange]
  );

  return (
    <>
      <QITable
        headers={header}
        data={data || []}
        handler={tableHandlers}
        highlight={highlight}
        setHighlight={setHighlight}
        listType={listType}
        showSelected={true}
        selectedId={selectedId}
        className="events custom-events-01"
        onScrollFrame={({ top }) => {
          if (top >= LOAD_MORE_THRESHOLD && hasMore && !isLoadingMore) {
            onLoadMore();
          }
        }}
      />
      <aside className="qi-pagination-wrapper">
        <QISlideSelect pagination={batchControl} />
        {isLoadingMore && <QISpinner size="20px" />}
      </aside>
    </>
  );
};
